const selfInstantiateOnLoad = (c) => {
    if (document.readyState === "complete") {
        new c();
    }
    else {
        document.addEventListener("DOMContentLoaded", () => new c());
    }
};
export default selfInstantiateOnLoad;
